import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../../../services/auth.service';
import {NavigationService} from '../../../services/navigation.service';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-staff-fetch-details',
  templateUrl: './staff-fetch-details.component.html',
  styleUrls: ['./staff-fetch-details.component.scss'],
})
export class StaffFetchDetailsComponent implements OnInit {

  key: string;

  constructor(private route: ActivatedRoute, private http: HttpClient, private auth: AuthService, private nav: NavigationService) { }

  ngOnInit() {
    this.key = this.route.snapshot.queryParamMap.get("uflsStaffSession");
    this.http.get('https://backend.furrydelphia.org/app/redirect/'+(environment.production ? 'fdregui' : 'fdreglocal')+'/otp/'+this.key+'/')
      .subscribe(
        (res: any) => {
          console.log(res)
          this.auth.activeUser = res;
          localStorage.setItem('fdregui-activeUser', JSON.stringify(res));
          localStorage.setItem('fdregui-timeStamp', new Date().toISOString());
          this.auth.loginChecked = true;
          this.auth.loggedIn = true;
          this.nav.navigate("/");
          window.location.reload();
        },
        (err) => {
          //console.log(err);
          this.nav.navigate("/");
        }
      )
  }

}
